// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"Uploader_dropzone__lwbUv","active":"Uploader_active__1_zu3"};